import styled from "styled-components/macro";
import { SmileyReactiveComponent } from "./SmileyReactiveComponent";

interface SmileyRatingProps {
	emotionLevel: number;
	onSelect?: () => void;
	isDisabled?: boolean;
}

export const SmileyRating: React.FC<SmileyRatingProps> = ({ emotionLevel, onSelect, isDisabled = false }) => {
	return (
		<Container>
			{[1, 2, 3, 4, 5].map((level) => (
				<div key={level} onClick={!isDisabled ? () => onSelect(level) : () => {}}>
					<SmileyReactiveComponent emotionLevel={level} isSelected={emotionLevel === level} isDisabled={isDisabled} />
				</div>
			))}
		</Container>
	);
};

const Container = styled.div`
	width: fit-content;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
